export enum TypeNotifications {
    INCREASE = 'increase',
    EXPIRED = 'expired',
    REQUERIMENTS = 'requeriments',
    NEWS = 'news',
    OBSERVATIONS = 'observations',
}
